import React from 'react';
import {useTranslation} from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from './assessmentResources.module.scss';

export function CreditDisclaimerCard() {
    const {t} = useTranslation(); 
    return (
        <div className={styles.containerCredit}>
            <InfoOutlinedIcon />
            <p className={styles.textCredit}>
                {t('ACCOUNTS_PAGE.ASSESSMENT_CREDIT_EDIT')}
            </p>
        </div>
    );
}
